var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16.0510582px",
    height: "16.0510582px",
    viewBox: "0 0 16.0510582 16.0510582",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Administrateur---Param\\xE8tres---Cat\\xE9gories",
    transform: "translate(-1390.666667, -335.282275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(40.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1348.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 22 0 22 22 0 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66666667,18.3333333 L7.33333333,18.3333333 L16.9583333,8.70833333 C17.9708553,7.69581129 17.9708553,6.05418872 16.9583333,5.04166669 C15.9458113,4.02914466 14.3041887,4.02914465 13.2916667,5.04166667 L3.66666667,14.6666667 L3.66666667,18.3333333",
    id: "Path",
    stroke: "#030303",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.375,
    y1: 5.95833333,
    x2: 16.0416667,
    y2: 9.625,
    id: "Path",
    stroke: "#030303",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditDark);
export default __webpack_public_path__ + "static/media/icon_edit_dark.75039828e04924c6ad30d944ace9a489.svg";
export { ForwardRef as ReactComponent };